/**
 * インストラクター向け専属レッスン一覧で一度に取得するレッスンの上限件数。
 *
 * 全件取得による表示遅延を避けるための暫定対応。総件数は lessonsCountForInstructor から別途取得する。
 */
export const INSTRUCTOR_LESSON_FETCH_LIMIT = 100;
